<div class="wrapper">
    <app-enterprise-navigation></app-enterprise-navigation>
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>

        <section class="content-header">
            <div class="row">
                <div class="col-md-6">
                    <div class="tab-heading">
                        <span class="tab-heading-title">Transfer to Bank</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="add-section width-50" style="margin-top: 8px">
            <div class="row align-items-center">
                <div class="col-md-6 section-heading">Wallet Balance</div>

                <div class="col-md-6 text-right">
                    <button
                        class="wallet-balance-card__action-btn"
                        type="button"
                        (click)="submit()"
                        [disabled]="availableBalance <= 0">
                        Request Transfer to Bank
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <label>FULL:</label>
                    <div>{{ fullBalance | currencyFormat }}</div>
                </div>

                <div class="col-md-6">
                    <label>AVAILABLE:</label>
                    <div>{{ availableBalance | currencyFormat }}</div>
                </div>
            </div>
        </section>

        <section *ngIf="search">
            <div class="search-result-header">Transfer History</div>
            <hr />

            <div
                class="container-fluid tab-pane custom-table custom-last-row"
                *ngIf="transactionList">
                <br />

                <table class="tableData">
                    <thead>
                        <tr>
                            <th>
                                <app-filter-arrow
                                    filter="name"
                                    title="DATE & TIME REQUESTED"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th>
                                <app-filter-arrow
                                    filter="role"
                                    title="STATUS"
                                    (filterValue)="receiveFilter($event)">
                                </app-filter-arrow>
                            </th>
                            <th>
                                <app-filter-arrow title="AMOUNT"></app-filter-arrow>
                            </th>
                            <th>
                                <app-filter-arrow title="ACTIONS"></app-filter-arrow>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr class="tablebox" *ngFor="let tran of transactionList">
                            <td>{{ tran.receivedAt | date: 'dd MMM yyyy HH:mm' }}</td>

                            <td>
                                <app-account-status
                                    type="transaction"
                                    transactionStatus="{{ tran.status }}">
                                </app-account-status>
                            </td>

                            <td>{{ tran.amount }}</td>

                            <td>
                                <app-last-child-enterprise-ttb
                                    (event)="action($event)"
                                    [transaction]="tran">
                                </app-last-child-enterprise-ttb>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot *ngIf="pagination.showPagination()">
                        <tr>
                            <td>
                                Rows per page:
                                <span>
                                    <b>{{ pagination.length }}</b>
                                </span>
                                <app-page-length-dropdown (emitLength)="changeLength($event)">
                                </app-page-length-dropdown>
                            </td>

                            <td>
                                <app-page-navigation
                                    pageNumber="{{ pagination.getPageNo() }}"
                                    totalPages="{{ pagination.getTotalPages() }}"
                                    (changePage)="changePage($event)">
                                </app-page-navigation>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </section>

        <div
            id="settlementViewModal"
            class="transaction-details-window"
            [style.display]="displayView">
            <div class="transaction-details-header">
                <div class="section-heading">
                    Bank Transfer Details
                    <a (click)="closeViewModel()">
                        <img class="float-right" src="assets/images/close-x-purple.png" />
                    </a>
                </div>

                <hr />

                <div class="transaction-details-header-body">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">USER OR BUSINESS NAME</label>
                            <div class="user-details-text">
                                <strong>{{ transaction.fromUserName }}</strong>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label"></label>
                            <app-account-status
                                type="transaction"
                                transactionStatus="{{ transaction.status }}">
                            </app-account-status>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">USER TYPE</label>
                            <div class="user-details-text">
                                {{ transaction.fromRole | humanize }}
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">RECEIVED</label>
                            <div class="user-details-text">
                                {{ transaction.receivedAt | date: dateFormat }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">Request Fee</label>
                            <div class="user-details-text">
                                {{ transaction.senderFee || 0 | currencyFormat }}
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">DUE</label>
                            <div class="user-details-text">
                                {{ transaction.settleOn | date: dateFormat }}
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div class="section-heading">Bank Details</div>

                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">BANK</label>
                            <div class="user-details-text">
                                {{ transaction.bankDetails.bankName }}
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">BRANCH</label>
                            <div class="user-details-text">
                                {{ transaction.bankDetails.bankLocation }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">ACCOUNT NUMBER</label>
                            <div class="user-details-text">
                                {{ transaction.bankDetails.accountNumber }}
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label">BRANCH NUMBER</label>
                            <div class="user-details-text">
                                {{ transaction.bankDetails.branchCode }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label">ACCOUNT HOLDER</label>
                            <div class="user-details-text">
                                {{ transaction.bankDetails.accountHolderName }}
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div class="section-heading">Logs</div>

                    <table>
                        <tbody>
                            <tr *ngFor="let tran of transaction.transactionLog">
                                <td class="pb-2">
                                    <div class="transaction-details-log-date">
                                        <label class="form-label mb-0">
                                            {{ tran.createdAt | date: 'd/M/yyyy - h:mm a' }}
                                        </label>
                                    </div>

                                    <div
                                        class="circle-left circle-green"
                                        *ngIf="tran.status === transactionStatusEnum.success"></div>

                                    <div
                                        class="circle-left circle-green"
                                        *ngIf="tran.status === transactionStatusEnum.settled"></div>

                                    <div
                                        class="circle-left circle-red"
                                        *ngIf="tran.status === transactionStatusEnum.failed"></div>

                                    <div
                                        class="circle-left circle-red"
                                        *ngIf="
                                            tran.status === transactionStatusEnum.cancelled
                                        "></div>

                                    <div
                                        class="circle-left circle-yellow"
                                        *ngIf="tran.status === transactionStatusEnum.pending"></div>

                                    <div
                                        class="circle-left circle-orange"
                                        *ngIf="
                                            tran.status === transactionStatusEnum.processing
                                        "></div>

                                    {{ tran.message }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="transaction-details-footer">
                Amount:
                <span class="float-right pr-3">
                    {{ transaction.amount | currencyFormat }}
                </span>
            </div>
        </div>

        <div id="cancelSettlementModal" class="image-modal" [style.display]="displayCancel">
            <div class="logout-window">
                <div class="section-heading mb-1">Cancel your Transfer Request?</div>

                <div>
                    <button
                        type="submit"
                        class="box-outline submit-btn mb-2"
                        (click)="cancelRequest()">
                        Cancel Request
                    </button>

                    <a class="deny-window-close" (click)="closeCancelModel()">
                        <u>BACK</u>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="control-sidebar-bg"></div>
</div>
